import { setDiscoveryLoadMoreError } from "../allowedSitesSlice";
import { searchAvailableSites } from "./searchAvailableSites";

export const retryAvailableSitesSearch =
  ({ isCloudMode }) =>
  (dispatch) => {
    dispatch(setDiscoveryLoadMoreError(false));
    return dispatch(searchAvailableSites({ isCloudMode, append: true }));
  };
